import { forwardRef } from 'react';
import styled from '@emotion/styled';
import { colorsButton } from 'app/colors';
import { TextEllipsis } from 'components/Kizen/Table';
import Icon from 'components/Kizen/Icon';
import IconButton from 'components/Kizen/IconButton';
import { useTruncationTooltip } from 'components/Kizen/Tooltip';
import { useTranslation } from 'react-i18next';

const ViewWrapper = styled.div`
  display: flex;
  && > button {
    display: none;
    margin-left: 10px;
    width: 12px;
    height: 12px;
    svg {
      width: 12px;
      height: auto;
    }
  }
  &&:hover,
  tr:hover &&,
  .InlineHoverable:hover && {
    > button {
      display: inline-block;
    }
  }
`;

const ShortTextViewDisplay = forwardRef(
  (
    {
      type,
      to,
      value,
      icon,
      onClickEditButton,
      disabled,
      emptyPlaceholder,
      target,
      rel,
      onClick,
      tooltipOverride,
      ...others
    },
    ref
  ) => {
    const { t } = useTranslation();
    const [tooltipProps, tooltip] = useTruncationTooltip(tooltipOverride);

    return (
      <ViewWrapper ref={ref} {...others}>
        <TextEllipsis
          type={type}
          onClick={onClick}
          to={to}
          color={disabled ? 'var(--color-font-placeholder)' : undefined}
          disabled={disabled}
          target={target}
          rel={rel}
          {...tooltipProps}
        >
          {Array.isArray(value) && (value.length ? value : emptyPlaceholder)}
          {!Array.isArray(value) &&
            (value || value === 0 ? value : emptyPlaceholder)}
        </TextEllipsis>
        {tooltip}
        {icon && (
          <>
            <IconButton
              sizing="dense"
              title={t('Edit Cell')}
              color={
                disabled
                  ? 'var(--color-button-tertiary-default)'
                  : colorsButton.iconGray
              }
              onClick={onClickEditButton}
            >
              <Icon icon={icon} />
            </IconButton>
          </>
        )}
      </ViewWrapper>
    );
  }
);

ShortTextViewDisplay.displayName = 'ShortTextViewDisplay';

ShortTextViewDisplay.defaultProps = {
  value: null,
  type: undefined,
  to: undefined,
  icon: 'pen',
  disabled: false,
  emptyPlaceholder: '—',
  target: null,
  rel: null,
};

export default ShortTextViewDisplay;
